import React, { useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import styled from "styled-components";
import { Menu, Dropdown } from 'antd';

import { Icon } from "semantic-ui-react";
import iconMember from "../../assets/images/icons/IconmembersIcon.png";
import iconMarketplace from "../../assets/images/icons/Icons24pxBagmarketplace.png";
import iconNews from "../../assets/images/icons/newsnewspaper-regular.png";

import { routes } from "../../helpers/routes";
import { toast } from "react-toastify";
import { Context } from "../../context/globalContext";
import { trackPage } from "../../helpers/analytics";


function goToSynapse(email, password, host) {
  trackPage('/synapse');
  fetch(`https://${host}/api/v1/login`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      user: email,
      password: password,
    }),
  })
    .then((r) => r.json())
    .then((res) => {
      const userId = res?.data?.userId;
      const token = res?.data?.authToken;
      console.log(userId, token);
      window.open(
        `https://${host}/home?resumeToken=${token}&userId=${userId}`,
        "_blank"
      );
    })
    .catch((error) => {
      toast.error("An error ocurred");
      console.error(error);
    });
}

export default function HeaderMenu({synapseNotificationsCount}) {
  const {
    state: { user },
  } = useContext(Context);

 
  return (
    <MenuItems>
      <HideItem mediaHide={700}>
        <HeaderMenuLink route={"/"} icon='home' text='home' />
      </HideItem>
      <HideItem mediaHide={800}>
        <HeaderMenuLink route={routes.PEOPLE} image={iconMember} text='members' />
      </HideItem>
      <HideItem mediaHide={950}>
        <HeaderMenuLink
          bubbleCount={synapseNotificationsCount}
          onClick={() => goToSynapse(user.email,process.env.REACT_APP_ROCKET_PASS,process.env.REACT_APP_ROCKET_HOST)}
          icon='comments outline'
          text='synapse'
        />
      </HideItem>
      <HideItem mediaHide={1100}>
        <HeaderMenuLink
          route={routes.MARKET_PLACE}
          image={iconMarketplace}
          text='marketplace'
        />
      </HideItem>
     
      <DropdownSubMenu
        overlay={(
          <Menu>
            <ShowItem mediaShow={700}>
              <HeaderMenuLink route={"/"} icon='home' text='home' />
            </ShowItem>
            <ShowItem mediaShow={800}>
              <HeaderMenuLink route={routes.PEOPLE} image={iconMember} text='members' />
            </ShowItem>
            <ShowItem mediaShow={950}>
              <HeaderMenuLink
                bubbleCount={synapseNotificationsCount}
                onClick={() => goToSynapse(user.email,process.env.REACT_APP_ROCKET_PASS,process.env.REACT_APP_ROCKET_HOST)}
                icon='comments outline'
                text='synapse'
              />
            </ShowItem>
            <ShowItem mediaShow={1100}>
              <HeaderMenuLink
                route={routes.MARKET_PLACE}
                image={iconMarketplace}
                text='marketplace'
              />
            </ShowItem>
            <HeaderMenuLink route={routes.NEWS} image={iconNews} text='news' />
            <HeaderMenuLink icon="align justify" text="Applicant database" route={"/applicant-database"}/>
            <HeaderMenuLink text="Schools" icon="hospital outline" route="/schools"/>
            <HeaderMenuLink text="Confessions" icon="talk" route="/confessions"/>
          </Menu>
        )}
      >
        <MoreButton>
          <BurgerMenu name='bars' />
          <HideItemRow mediaHide={700}>
            more
            <Icon name='caret down' />
          </HideItemRow>
        </MoreButton>
      </DropdownSubMenu> 
    </MenuItems>
  );
}

function HeaderMenuLink({ route, image, text, icon, onClick, bubbleCount }) {
  return (
    <HeaderMenuLinkDiv onClick={onClick}>
      {route ? (
        <LinkButton to={route}>
          {icon ? (
            <IconImage size='large' name={icon} />
          ) : (
            <LinkImage src={image} />
          )}

          <LinkText>
            {text}
            {(bubbleCount>0)&&(
              <CountBubble>{bubbleCount}</CountBubble>
            )}
          </LinkText>
        </LinkButton>
      ) : (
        <NoLink>
          <IconImage size='large' name={icon} />
          <LinkText>
            {text}
            {(bubbleCount>0)&&(
              <CountBubble>{bubbleCount}</CountBubble>
            )}
          </LinkText>
        </NoLink>
      )}
    </HeaderMenuLinkDiv>
  );
}

const BurgerMenu = styled(Icon)`&&{
  @media (max-width: 700px) {
    font-size:1.3em;
  }
}
`;
const HideItem = styled.div`&&{
  @media (max-width: ${p=>p.mediaHide}px) {
    display: none;
  }
}
`;
const HideItemRow = styled(HideItem)`
  display:flex;
`;
const ShowItem = styled.div`
  display: none;
  @media (max-width: ${p=>p.mediaShow}px) {
    display: block;
  }
`;
const MoreButton = styled.span`
  display:flex;
  flex-direction: row;
  cursor: pointer;
  padding: 8px 8px;
  @media (max-width: 700px) {
    padding: 0px 12px;
  }
`;
const LinkButton = styled(NavLink)`
  display: flex;
  flex-direction: row;

  cursor: pointer;
  padding: 5px;
  margin-right: 20px;
`;
const NoLink = styled.div`
  display: flex;
  flex-direction: row;

  cursor: pointer;
  padding: 5px;
  margin-right: 20px;
`;
const LinkText = styled.p`
  color: rgb(17, 23, 66);
  font-size: 16px;
  font-weight: bold;
  height: 24px;
  letter-spacing: 0.1px;

  margin-left: 10px;
  padding-top: 2px;
  padding-bottom: auto;
  position: relative;
`;
const MenuItems = styled.div`
  display: flex;
  flex:1;
  justify-content: center !important;
  flex-direction: row;
  font-family: Helvetica;
  color: rgb(17, 23, 66);
  @media (max-width: 700px) {
    flex:initial;
  }
`;

const LinkImage = styled.img`
  height: 18px;
`;
const DropdownSubMenu = styled(Dropdown)`&&&{
  padding-top: 5px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
}
`;

const IconImage = styled(Icon)`
  color: rgb(17, 23, 66);
  height: 24px;
  font-weight: bold;
`;

const HeaderMenuLinkDiv = styled.div``;

const CountBubble = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background-color: #ff4d4f;
  position: absolute;
  top: -10px;
  right: -14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
`;